import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  standalone: false,
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
